// ─── Inline SVG Icons ────────────────────────────────────────────────────────

export function Ico({ size = 14, cls = "", spin = false, children }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={[cls, spin ? "ico-spin" : ""].filter(Boolean).join(" ")}
      style={{
        flexShrink: 0,
        display: "inline-block",
        verticalAlign: "middle",
      }}
    >
      {children}
    </svg>
  );
}

export const IcoCheckCircle = ({ size = 14, cls = "" }) => (
  <Ico size={size} cls={cls}>
    <circle cx="12" cy="12" r="10" />
    <path d="m9 12 2 2 4-4" />
  </Ico>
);
export const IcoAlertCircle = ({ size = 14, cls = "" }) => (
  <Ico size={size} cls={cls}>
    <circle cx="12" cy="12" r="10" />
    <line x1="12" x2="12" y1="8" y2="12" />
    <line x1="12" x2="12.01" y1="16" y2="16" />
  </Ico>
);
export const IcoBuilding2 = ({ size = 14, cls = "" }) => (
  <Ico size={size} cls={cls}>
    <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" />
    <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" />
    <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" />
    <path d="M10 6h4" />
    <path d="M10 10h4" />
    <path d="M10 14h4" />
    <path d="M10 18h4" />
  </Ico>
);
export const IcoUser = ({ size = 14, cls = "" }) => (
  <Ico size={size} cls={cls}>
    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </Ico>
);
export const IcoX = ({ size = 14, cls = "" }) => (
  <Ico size={size} cls={cls}>
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </Ico>
);
export const IcoClock = ({ size = 14, cls = "" }) => (
  <Ico size={size} cls={cls}>
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </Ico>
);
export const IcoLoader = ({ size = 14, cls = "" }) => (
  <Ico size={size} cls={cls} spin>
    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
  </Ico>
);
export const IcoCheckCircle2 = ({ size = 14, cls = "" }) => (
  <Ico size={size} cls={cls}>
    <circle cx="12" cy="12" r="10" />
    <path d="m8 12 2.5 2.5L16 9" />
  </Ico>
);
export const IcoXCircle = ({ size = 14, cls = "" }) => (
  <Ico size={size} cls={cls}>
    <circle cx="12" cy="12" r="10" />
    <path d="m15 9-6 6" />
    <path d="m9 9 6 6" />
  </Ico>
);
export const IcoCircleMinus = ({ size = 14, cls = "" }) => (
  <Ico size={size} cls={cls}>
    <circle cx="12" cy="12" r="10" />
    <path d="M8 12h8" />
  </Ico>
);
export const IcoBadgeCheck = ({ size = 14, cls = "" }) => (
  <Ico size={size} cls={cls}>
    <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" />
    <path d="m9 12 2 2 4-4" />
  </Ico>
);
export const IcoChevLeft = ({ size = 14, cls = "" }) => (
  <Ico size={size} cls={cls}>
    <path d="m15 18-6-6 6-6" />
  </Ico>
);
export const IcoChevRight = ({ size = 14, cls = "" }) => (
  <Ico size={size} cls={cls}>
    <path d="m9 18 6-6-6-6" />
  </Ico>
);
export const IcoChevDown = ({ size = 14, cls = "" }) => (
  <Ico size={size} cls={cls}>
    <path d="m6 9 6 6 6-6" />
  </Ico>
);
export const IcoSearch = ({ size = 14, cls = "" }) => (
  <Ico size={size} cls={cls}>
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.3-4.3" />
  </Ico>
);
export const IcoDownload = ({ size = 13, cls = "" }) => (
  <Ico size={size} cls={cls}>
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" x2="12" y1="15" y2="3" />
  </Ico>
);
export const IcoSquare = ({ size = 15, cls = "" }) => (
  <Ico size={size} cls={cls}>
    <rect width="18" height="18" x="3" y="3" rx="2" />
  </Ico>
);
export const IcoSquareCheck = ({ size = 15, cls = "" }) => (
  <Ico size={size} cls={cls}>
    <rect width="18" height="18" x="3" y="3" rx="2" />
    <path d="m9 12 2 2 4-4" />
  </Ico>
);
export const IcoSquareMinus = ({ size = 15, cls = "" }) => (
  <Ico size={size} cls={cls}>
    <rect width="18" height="18" x="3" y="3" rx="2" />
    <path d="M8 12h8" />
  </Ico>
);
export const IcoSliders = ({ size = 14, cls = "" }) => (
  <Ico size={size} cls={cls}>
    <line x1="21" x2="14" y1="4" y2="4" />
    <line x1="10" x2="3" y1="4" y2="4" />
    <line x1="21" x2="12" y1="12" y2="12" />
    <line x1="8" x2="3" y1="12" y2="12" />
    <line x1="21" x2="16" y1="20" y2="20" />
    <line x1="12" x2="3" y1="20" y2="20" />
    <line x1="14" x2="14" y1="2" y2="6" />
    <line x1="8" x2="8" y1="10" y2="14" />
    <line x1="16" x2="16" y1="18" y2="22" />
  </Ico>
);
export const IcoSend = ({ size = 13, cls = "" }) => (
  <Ico size={size} cls={cls}>
    <path d="m22 2-7 20-4-9-9-4Z" />
    <path d="M22 2 11 13" />
  </Ico>
);
export const IcoTriangle = ({ size = 13, cls = "" }) => (
  <Ico size={size} cls={cls}>
    <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
    <path d="M12 9v4" />
    <path d="M12 17h.01" />
  </Ico>
);
export const IcoEraser = ({ size = 15, cls = "" }) => (
  <Ico size={size} cls={cls}>
    <path d="m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21" />
    <path d="M22 21H7" />
    <path d="m5 11 9 9" />
  </Ico>
);
